export const contentDict = {
  title: "Depth-Guided Dynamic NeRF",                // Display name
  finishDate: new Date("2022-07-01"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Python": 0.5,
    "PyTorch": 0.5, 
  }, 
  description: 
    `Our approach DGD-NeRF reduces the rerendering error by improving and extending existing dynamic NeRF by depth 
    using an RGB-D dataset. We constrain the optimization by depth supervision and depth-guided sampling.`,
  tags: ["ML", "CV", "Neural Rendering"],
  github: "https://github.com/philippwulff/DGD-NeRF",    // Can also be `null`
  website: "https://philippwulff.github.io/DGD-NeRF/",       // Can also be `null`
  images: [
    "https://philippwulff.github.io/DGD-NeRF/static/images/model.png",
    "https://philippwulff.github.io/DGD-NeRF/static/images/human_capture.mp4",
  ],
  coverImg: "https://philippwulff.github.io/DGD-NeRF/static/images/model.png",
  mainColor: "#000",
  authors: ["Philipp Wulff", "Johannes Kirmayr"],
  isResearch: true,    // Whether this should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }